import { DocReaderVariantType } from '../../../../../../components/docReader/types/docReaderVariantType';
import { FONT_WEIGHT } from '../../../foundations/typography';
import { ButtonSizeType, ButtonVariantType } from '../../button/variants';
import { TextVariantType } from '../../text/variants';
export const getNeutralStyles = (FOUNDATIONS, FONT) => {
    return {
        [DocReaderVariantType.NEUTRAL]: {
            rootContainer: {
                width: '100%',
                display: 'flex',
                flex_direction: 'row',
                justify_content: 'space-between',
                gap: FOUNDATIONS.spacing_150,
                align_items: 'center',
                padding: `${FOUNDATIONS.spacing_100} ${FOUNDATIONS.spacing_250}`,
                border_radius: '1rem',
                background_color: FOUNDATIONS.color_comp_containers_bg,
            },
            dataContainer: {
                display: 'flex',
                flex_direction: 'row',
                gap: FOUNDATIONS.spacing_150,
                align_items: 'flex-start',
                padding: `${FOUNDATIONS.spacing_200} ${FOUNDATIONS.spacing_00}`,
            },
            titleContainer: {
                display: 'flex',
                flex_direction: 'column',
                row_gap: FOUNDATIONS.spacing_50,
            },
            leftIcon: {
                color: FOUNDATIONS.color_neutral_icon_50,
                width: FOUNDATIONS.size_300,
                height: FOUNDATIONS.size_300,
            },
            title: {
                font_variant: TextVariantType.FONT_PARAGRAPH_400,
                color: FOUNDATIONS.color_neutral_font_50,
                font_weight: FONT_WEIGHT.font_bold,
                text_align: 'left',
                display: '-webkit-box',
                webkit_line_clamp: '2',
                webkit_box_orient: 'vertical',
                overflow: 'hidden',
                text_overflow: 'ellipsis',
            },
            label: {
                font_variant: TextVariantType.FONT_PARAGRAPH_500,
                color: FOUNDATIONS.color_neutral_font_100,
                font_weight: FONT_WEIGHT.font_regular,
                display: '-webkit-box',
                text_align: 'left',
                webkit_line_clamp: '2',
                webkit_box_orient: 'vertical',
                overflow: 'hidden',
                text_overflow: 'ellipsis',
            },
            statusIcon: {
                color: FOUNDATIONS.color_feedback_success_icon_50,
                width: FOUNDATIONS.size_300,
                height: FOUNDATIONS.size_300,
            },
            action: {
                variant: ButtonVariantType.PRIMARY,
                size: ButtonSizeType.SMALL,
            },
            isMandatory: true,
        },
    };
};
//# sourceMappingURL=neutral.js.map